import { ROUTES } from 'routes'
import { AuthorizedProductsRoute } from './AuthorizedProductsRoute'

import type { RouteObject } from 'react-router-dom'

export const productRoutes: RouteObject[] = [
  {
    element: <AuthorizedProductsRoute />,
    path: ROUTES.PRODUCT.LIST,
  },
]
